<template>
<div class="table-container">
  <table>

    <tr class="header-table">
      <th>ارز</th>
      <th class="hide-400">زمان وتاریخ</th>
      <th>مقدار</th>
      <th class="hide-992">کارمزد</th>
      <th class="hide-992">شبکه</th>
      <th class="hide-992">آدرس مقصد</th>
      <th class="hide-500">شناسه تراکنش</th>
      <th>وضعیت</th>
    </tr>
    <tr class="body" v-for="(item , index) in transactions" :key="index+1">
      <td>
        <div class="name-area">
          <!--          <img :src="require('@/assets/coins/'+$coinUnit[item.relatedCoin]+'.png')" width="24px"/>-->
          <div class="text">
            <span>{{ $coins[item.relatedCoin].persianName }}</span>
            <small>{{ $coins[item.relatedCoin].code }}</small>
          </div>
        </div>
      </td>

      <td class="hide-400">`
        <span>
        {{ $G2J(item.createdAtDateTime) }}
          </span>
      </td>

      <td>
         <span>
        {{ $toLocal(item.amount,$decimal[item.relatedCoin]) }}
        </span>
      </td>

      <td class="hide-992">
         <span>
        {{ state.userInfo.fee }}
        </span>
      </td>

      <td class="hide-992">
         <span>
        {{ item.tokenType }}
        </span>
      </td>

      <td class="hide-992">
         <span>
        {{ item.bankAccount ? item.bankAccount : item.destinationWalletAddress }}
        </span>
      </td>

      <td class="hide-500">
         <span class="link">
        {{ item.id }}
        </span>
      </td>

      <td>
         <span :class="{'green':item.isDone ?  'موفق' :'' , 'red':!item.isDone === 'ناموفق'}">
        {{ item.isDone ? 'موفق' :'ناموفق' }}
         </span>
      </td>
    </tr>
  </table>
</div>
</template>

<script>
export default {
  name: "usdtTrHistory",
props:['query'],
  data() {
    return {

// query:{},
      //transaction history

      transactions:[],

    }
  },

  watch:{

        'query'() {
      let query = this.query
 if(!query.descendingDate){

   if(query.startDate && query.endDate){
// console.log('start',query.startDate,'end',query.endDate)

     this.transactions= this.transactions.sort((a,b)=>{ return new Date(a.createdAtDateTime)  - new Date(b.createdAtDateTime)})









     // this.transactions = this.transactions.filter(item=>{
     //
     //   const start = new Date(query.startDate)
     //   const end = new Date(query.endDate)
     //
     //  console.log('start  date', new Date(query.startDate)
     //  )
     //   console.log('end date', new Date(query.endDate))
     //   console.log( 'item date',new Date(item.createdAtDateTime))
     //
     //
     // })
   }


 else  this.transactions= this.transactions.sort((a,b)=>{ return new Date(a.createdAtDateTime)  - new Date(b.createdAtDateTime)})
}
 else if(query.descendingDate){
   this.transactions= this.transactions.sort((a,b)=>{ return new Date(b.createdAtDateTime)  - new Date(a.createdAtDateTime)})

}


if(query.startDate && query.endDate !==''){
  // console.log(new Date(query.startDate) , new Date(query.endDate))

const filteredToDates = this.transactions.filter(
  (record)=>{
    return new Date(record.createdAtDateTime) >= new Date(query.startDate) && new Date(record.createdAtDateTime) <= new Date(query.endDate)
  }
)

// console.log(filteredToDates)
}




if(query.coin.coin == ''){





  return this.transactions 
}
//
else if(query.coin){







  
this.transactions=  this.transactions.filter(transaction => {
    return transaction.relatedCoin == query.coin[0]     
})


      
}










else return this.transactions
    },


  },
//   computed:{
// filterTransaction(){
//   let query = this.query 
//   // console.log(this.query)
//   let filter = this.transactions




//   if(this.query !==''){
//     filter = this.transactions.filter(a=>{a.relatedCoin.includes(query.coin[0])})
//   }
  
  
//   return filter;
// }
    
//   },
     methods:{
        async getCryptoTransactions(){
           this.state.loading=true;  
      let withdrawals = await this.$axios.get('/wallets/withdrawal-requests?size=1000')
      let deposits = await this.$axios.get('/wallets/deposit?size=1000')
withdrawals = withdrawals.content
deposits = deposits.content
deposits = deposits.filter(el =>el.relatedCoin !=='TOMAN')
withdrawals = withdrawals.filter(el =>el.relatedCoin !=='!TOMAN')
let concats = deposits.concat(withdrawals)

// concats = concats.sort((a,b)=>{
// a.createdAtDateTime < b.createdAtDateTime


// })


this.transactions = concats
// console.table(concats)

    },





    
    },
     mounted(){
    
       this.getCryptoTransactions()
     },
  
}
</script>

<style lang="scss" scoped>
.table-container{
  height: 300px;
  overflow-y: scroll;
}


table {

  table-layout: auto !important;
  height: 300px;
  ovrflow-y: scroll;

  th {
    font-size: clamp(10px , 1vw , 14px);
    color: #D7C8C8;
    background-color: #091222;
    text-align: center;

    &:first-child {
      text-align: right !important;
    }

    &:last-child {
      text-align: left !important;
    }
  }

  td {
    font-size: clamp(10px , 1vw , 14px);
    color: #D7C8C8;
    height: 40px;
    text-align: center;

    &:first-child {
      text-align: right !important;
    }

    &:last-child {
      text-align: left !important;
    }

    .link {
      color: #1199FA;
      text-decoration: underline;
      cursor: pointer;
    }
  }

  .header-table {
    height: 65px;
    position: sticky;
    top: 0;

    &:first-child {
      text-align: right;
    }

    &:last-child {
      text-align: left;
    }
  }

  .body {
    &:first-child {
      text-align: right;
    }

    &:last-child {
      text-align: left;
    }

    .name-area {
      display: flex;
      flex-direction: row;
      gap: 5px;
      align-items: center;

      .text {
        display: flex;
        flex-direction: column;

        span {
          font-size: clamp(10px , 1vw , 14px);
          color: rgba(215, 200, 200, 1);
        }

        small {
          font-size: clamp(10px , 1vw , 14px);
          color: rgba(215, 200, 200, 1);
        }
      }
    }
  }
}

@media (max-width: 992px) {
  .hide-992{
    display:none !important;
  }
}

@media (max-width: 768px) {
  .hide-768{
    display:none !important;
  }
}

@media (max-width: 500px) {
  .hide-500{
    display:none !important;
  }
}

@media (max-width: 400px) {
  .hide-400{
    display:none !important;
  }
}
</style>